import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ProfessionalRoute } from 'app/core/common/models/professionals-route.config';
import { AnalyticsDataService } from 'app/services/external/analytics/analytics.service';
import { PageViewEventFields } from 'app/services/external/analytics/models/analytics.config';

@Injectable({ providedIn: 'root' })
export class AnalyticsResolver {
  private readonly _analyticsDataService = inject(AnalyticsDataService);

  public resolve(route: ActivatedRouteSnapshot): void {
    const pageViewEventFields: PageViewEventFields = {
      route: route.routeConfig as ProfessionalRoute
    };
    this._analyticsDataService.trackEvent('page_view', pageViewEventFields);
  }
}
